module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8401/img/spiderweb-corner.png"